<i2a-delegate-folders [title]="name" [subTitle]="delegate.accesses.lastAccess | amDateFormat: 'LLL'"
  [delegate]="delegateFolders" [isAlert]="isAlert" [warningLevel]="warningLevel" [hasAlert]="hasAlert"
  [hasAlertRecentlyClosed]="hasAlertRecentlyClosed" (onWarnClick)="warnClick($event)"
  [buttonOpenAlertModalKey]="delegate != null && delegate.permissions != null ? 'button.openAlertModal' : 'button.openAlertModalAnomaly' ">
</i2a-delegate-folders>